var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55012 11.5734C5.41679 11.5734 5.29179 11.5524 5.17512 11.5104C5.05846 11.4691 4.95012 11.3984 4.85012 11.2984L0.550123 6.99844C0.36679 6.8151 0.279123 6.57744 0.287123 6.28544C0.29579 5.9941 0.391789 5.75677 0.575122 5.57344C0.758456 5.3901 0.991789 5.29844 1.27512 5.29844C1.55846 5.29844 1.79179 5.3901 1.97512 5.57344L5.55012 9.14844L14.0251 0.673438C14.2085 0.490104 14.4461 0.398438 14.7381 0.398438C15.0295 0.398438 15.2668 0.490104 15.4501 0.673438C15.6335 0.856771 15.7251 1.0941 15.7251 1.38544C15.7251 1.67744 15.6335 1.9151 15.4501 2.09844L6.25012 11.2984C6.15012 11.3984 6.04179 11.4691 5.92512 11.5104C5.80846 11.5524 5.68346 11.5734 5.55012 11.5734Z",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingCheck);
export default __webpack_public_path__ + "static/media/pricing-check.5e1d72247621e3af79bd741f2734bec8.svg";
export { ForwardRef as ReactComponent };